import React from 'react'
import { useAddress } from '@thirdweb-dev/react'
import { truncateAddress } from '~/components/shared/address'
import { NftTrait, findTraitByType } from '~/domain/NftTrait'
import styles from './index.module.scss'
import { Item } from '~/domain/Item'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

interface NftInfoProps {
  item: Item
  owner: string
}

export const NftInfo: React.FC<NftInfoProps> = ({ item, owner }) => {
  const address = useAddress()
  const title = item.nft.metadata.name
  const awardTypeAttribute = findTraitByType(
    item.nft.metadata.attributes as NftTrait[] | undefined,
    'Award Type'
  )
  const subtitle = awardTypeAttribute ? awardTypeAttribute.value : null

  return (
    <div 
      data-testid="nft-info"
      className={ styles['nft-info'] }  
    >
      <h1 className={ styles['nft-info__title'] } >
        { title }
      </h1>

      <h2 className={ styles['nft-info__subtitle'] }>
        { subtitle }
      </h2>

      <div className={ styles['nft-info__text'] }>
        <p>
          Owned by { }
          <a
            className={ styles['nft-info__link'] }
            href={ `/profile/${owner}` }
          >
            {
              address && owner === address
                ? 'you'
                : truncateAddress(owner)
            }
          </a>
        </p>

        {
          item.isFragment() &&
            <p className={ styles['nft-info__text__explore'] }>
              <a
                className={ styles['nft-info__link'] }
                href={ item.vaultUrl }
              >
                Explore vault { }
                <FontAwesomeIcon
                  icon={ faArrowRight }
                />
              </a>
            </p>
        }
      </div>
    </div>
  )
}
